<template>
  <div class="multimedia__content-grid multimedia__content-grid-modal">
    <div v-for="(videos, key) in videosList"
         :key="key">
      <div class="multimedia__content-grid-label"> {{ key }}</div>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div class="cell small-12 medium-6 large-4"
             v-for="(video, index) in videos"
             :key="`video-${index}`">
          <multimedia-video
            @selected="selectElement"
            :video="video"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MultimediaVideo from '@/components/multimedia/items/Video.vue';
import { CAROUSEL_OPEN } from '@/eventTypes';
import EventBus from '@/eventBus';

export default {
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  components: {
    MultimediaVideo,
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['getUserMultimedia']),
    videosList() {
      return this.getMultimedia.multimedia ?? {};
    },
    getMultimedia() {
      return this.getUserMultimedia(this.clientId, 'video') ?? {};
    },
  },
  methods: {
    selectElement(video) {
      if (video.multimedia) {
        const payload = {
          url: `${video.multimedia.file}?token=${this.token}`,
          type: 'video',
        };

        EventBus.$emit(CAROUSEL_OPEN, payload);
      }
    },
  },
};
</script>
